module.exports = __webpack_public_path__ + "static/media/blog177.c639e298.svg";